import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedCurrency, FormattedMessage } from '@divvy-web/i18n'
import BasicButton from '@divvy-web/skylab.basicbutton'

import styles from './styles.module.scss'

// only pass in approvedAmount or approvedAmountPlaceHolder, not both
interface OfferTileProps {
  onViewOfferDetailsClick: () => void
  approvedAmount?: number
  approvedAmountPlaceHolder?: ReactNode
  caption: ReactNode
  dataTestId?: string
  image: ReactNode
  pillWithImage: ReactNode
  title: ReactNode
}

const OfferTile = ({
  onViewOfferDetailsClick,
  approvedAmount = 0,
  approvedAmountPlaceHolder,
  caption,
  dataTestId,
  image,
  pillWithImage,
  title,
}: OfferTileProps) => {
  const [getClassName, makeTestId] = useNameFormatter('OfferTile', { dataTestId })

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      <div className={styles[getClassName('pill-with-image')]}>{pillWithImage}</div>
      <div className={styles[getClassName('image-and-text-wrapper')]}>
        <div>{image}</div>
        <div className={styles[getClassName('amount-and-title-wrapper')]}>
          {approvedAmount > 0 && (
            <div
              className={styles[getClassName('amount')]}
              data-testid={makeTestId('amount')}
            >
              <FormattedCurrency
                maximumFractionDigits={0}
                minimumFractionDigits={2}
                value={approvedAmount}
              />
            </div>
          )}
          {approvedAmountPlaceHolder && (
            <div
              className={styles[getClassName('amount-placeholder')]}
              data-testid={makeTestId('amount-placeholder')}
            >
              {approvedAmountPlaceHolder}
            </div>
          )}
          <div className={styles[getClassName('title')]}>{title}</div>
        </div>
        <div className={styles[getClassName('caption-wrapper')]}>{caption}</div>
      </div>
      <div className={styles[getClassName('button-wrapper')]}>
        <BasicButton
          className={styles[getClassName('review-offer')]}
          data-testid={makeTestId('details')}
          onClick={onViewOfferDetailsClick}
        >
          <FormattedMessage
            defaultMessage='View offer details'
            id='sputnik.OfferTile__PaI1h+'
          />
        </BasicButton>
      </div>
    </div>
  )
}

export default OfferTile
